import DomainResource from './DomainResource';
import merge from 'lodash/merge';
import Reference from './types/Reference';

export default class BN_CareTeamDepartment extends DomainResource {
    static _className = 'BN_CareTeamDepartment';

    _objectStructure = {
        name: String,
        status: String,
        practitioner: [Reference],
    };

    _objectDefaults = {
        experimental: false,
    };

    constructor(constructJson, className = 'BN_CareTeamDepartment') {
        super(constructJson, className);
        this.createAndPopulateStructure(this._objectStructure, constructJson, this._objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this._objectStructure));
    }
}
